import { container } from 'tsyringe';
import UserService from '../../user/model/userService';
import { API_HOST, ResponseCode } from '../../../utils/constants';
import { useCallback, useEffect, useState } from 'react';

import a0 from '@base/assets/avatars/svg/a0.svg';
import a1 from '@base/assets/avatars/svg/a1.svg';
import a2 from '@base/assets/avatars/svg/a2.svg';
import a3 from '@base/assets/avatars/svg/a3.svg';
import a4 from '@base/assets/avatars/svg/a4.svg';
import a5 from '@base/assets/avatars/svg/a5.svg';
import a6 from '@base/assets/avatars/svg/a6.svg';
import a7 from '@base/assets/avatars/svg/a7.svg';
import a8 from '@base/assets/avatars/svg/a8.svg';
import a9 from '@base/assets/avatars/9.png';
import a10 from '@base/assets/avatars/10.png';
import a11 from '@base/assets/avatars/11.png';
import a12 from '@base/assets/avatars/12.png';
import a13 from '@base/assets/avatars/13.png';
import a14 from '@base/assets/avatars/14.png';
import a15 from '@base/assets/avatars/15.png';
import a16 from '@base/assets/avatars/16.png';
import a17 from '@base/assets/avatars/17.png';
import a18 from '@base/assets/avatars/18.png';
import a19 from '@base/assets/avatars/19.png';
import a20 from '@base/assets/avatars/20.png';
import a21 from '@base/assets/avatars/21.png';
import a22 from '@base/assets/avatars/22.png';
import a23 from '@base/assets/avatars/23.png';
import a24 from '@base/assets/avatars/24.png';
import a25 from '@base/assets/avatars/25.png';
import a26 from '@base/assets/avatars/26.png';
import a27 from '@base/assets/avatars/27.png';
import a28 from '@base/assets/avatars/28.png';
import a29 from '@base/assets/avatars/29.png';
import { AccountRequest } from '../../user/model/interfaces';
import { getRequiredEnv, t } from '../../../utils/helpers';
import { IModalProvider } from '@base/features/modal/model/interfaces';

export type AvatarPickerState = {
  avatarImg: string;
  avatarsList: string[];
  selectedAvatar: number;
  showPickerAvatar: boolean;
  isProcessing: boolean;
  currentAvatar: number;
};

const avatarsList = [
  a0,
  a1,
  a2,
  a3,
  a4,
  a5,
  a6,
  a7,
  a8,
  a9,
  a10,
  a11,
  a12,
  a13,
  a14,
  a15,
  a16,
  a17,
  a18,
  a19,
  a20,
  a21,
  a22,
  a23,
  a24,
  a25,
  a26,
  a27,
  a28,
  a29,
];

const url = getRequiredEnv('NX_API_ENDPOINT');

export const useAvatarPicker = (
  usr: string,
  session: string,
  userId: string,
  socialAvatar?: string
): [AvatarPickerState, (key?: number) => void, () => void, () => void, (file: File) => void] => {
  const userService: UserService = container.resolve('userService');
  const modalProvider: IModalProvider = container.resolve('modalProvider');

  const initialAvatarPickerState = {
    avatarImg: avatarsList[0],
    avatarsList: avatarsList,
    selectedAvatar: -1,
    showPickerAvatar: false,
    isProcessing: true,
    currentAvatar: -1,
  };
  const [state, setState] = useState<AvatarPickerState>(initialAvatarPickerState);

  const getCustomAvatarUrl = (apiHost: string, userId: string): string => {
    return `${apiHost}get_avatar.plx?size=3&uid=${userId}`;
  };

  const showCustomAvatar = useCallback((apiHost: string, userId: string): void => {
    const customAvatarUrl = getCustomAvatarUrl(API_HOST, userId);
    setState((prevState) => {
      return {
        ...prevState,
        avatarImg: customAvatarUrl,
        isProcessing: false,
      };
    });
  }, []);
  const previewCustomAvatar = useCallback((file: File): void => {
    const previewAvatar = URL.createObjectURL(file);
    setState((prevState) => {
      return {
        ...prevState,
        avatarImg: previewAvatar,
        isProcessing: false,
      };
    });
  }, []);

  useEffect(() => {
    if (socialAvatar) {
      userService
        .setSocialAvatar(socialAvatar)
        .then((res) => {
          if (res.code === ResponseCode.SUCCESS) {
            setState((prevState) => {
              return {
                ...prevState,
                avatarImg: socialAvatar,
                isProcessing: false,
              };
            });
          } else {
            console.info('Не смогли установить пользователю аватар от соцсети', res);
          }
        })
        .catch((e) => console.error('fail setSocialAvatar', e));
    } else {
      userService
        .getPartAccountInfo(AccountRequest.FACE, usr, session)
        .then((res) => {
          setState((prevState) => ({ ...prevState, isProcessing: false }));
          if (res.code === ResponseCode.SUCCESS) {
            //check custom avatar
            if (res.id === '00' || res.id === '-1') {
              //ToDo выяснить почему -1 number приходит и обработать. Изменить тип в ResponseUserAuthData
              if (res.uploaded) showCustomAvatar(API_HOST, res.uploaded);
            } else {
              //default avatar
              const id = Number(res.id);
              setState((prevState) => {
                return {
                  ...prevState,
                  currentAvatar: id - 1,
                  avatarImg: avatarsList[id - 1],
                  selectedAvatar: id - 1,
                  isProcessing: false,
                };
              });
            }
          }
        })
        .catch((e) => {
          setState((prevState) => ({ ...prevState, isProcessing: false }));
          console.error('error', e);
        });
    }
  }, [socialAvatar, usr, session, userService, showCustomAvatar]);

  function handleSelectAvatar(key?: number) {
    if (key || key === 0) {
      setState({ ...state, selectedAvatar: key });
    } else {
      //reset selectedAvatar
      setState({ ...state, selectedAvatar: state.currentAvatar });
      handlePickerAvatar();
    }
    //userPicture && setUserPicture(null);
  }

  function handlePickerAvatar() {
    setState((prevState) => {
      const showPicker = prevState.showPickerAvatar;
      return {
        ...prevState,
        showPickerAvatar: !showPicker,
      };
    });
  }

  async function handlePickCustomAvatar(file: File) {
    //setUserPicture(file);
    //дизайн не предусматривает индикаторов загрузки и превью. Поэтому нужно сразу установить выбранный файл
    setState((prevState) => {
      return { ...prevState, isProcessing: true };
    });

    const data = new FormData();
    data.append('do', 'change_face');
    data.append('usr', usr);
    data.append('sid', session);
    data.append('avafile', file);

    try {
      const response = await userService.setCustomAvatar(url, data);
      setState({ ...state, isProcessing: false });
      if (response.code === ResponseCode.SUCCESS) {
        previewCustomAvatar(file);
        handlePickerAvatar();
      } else {
        modalProvider.show({
          title: t('error'),
          body: t('unknown_error_try_again'),
          buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
        });
      }
    } catch (e) {
      setState({ ...state, isProcessing: false });
      console.error('handlePickCustomAvatar error', e);
      modalProvider.show({
        title: t('error'),
        body: t('unknown_error_try_again'),
        buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
      });
    }
  }

  async function handlePickSystemAvatar() {
    setState((prevState) => {
      return { ...prevState, isProcessing: true };
    });
    try {
      const response = await userService.setSystemAvatar(state.selectedAvatar + 1);
      setState({ ...state, isProcessing: false });
      if (response.code === ResponseCode.SUCCESS) {
        handlePickerAvatar();
        setState((prevState) => {
          return {
            ...prevState,
            currentAvatar: state.selectedAvatar,
            avatarImg: avatarsList[state.selectedAvatar],
          };
        });
      } else {
        modalProvider.show({
          title: t('error'),
          body: t('unknown_error_try_again'),
          buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
        });
      }
    } catch (e) {
      setState({ ...state, isProcessing: false });
      console.error('handlePickSystemAvatar error', e);
      modalProvider.show({
        title: t('error'),
        body: t('unknown_error_try_again'),
        buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
      });
    }
  }

  return [state, handleSelectAvatar, handlePickerAvatar, handlePickSystemAvatar, handlePickCustomAvatar];
};
